/**
 * 部所異動履歴
 */
export type TBsyoIdoRirekiDataTable = {
  部所異動履歴データリスト: TBsyoIdoRirekiData[]
}

export type TBsyoIdoRirekiData = {
  row_id?: string
  所属部所ID: number
  所属開始日: string
  所属終了日: string
  会社コード: string
  会社名: string
  部所コード: string
  部所名: string
  備考: string
  削除フラグ?: number
  更新日時?: string
}

//#region 初期値

export const initialBsyoIdoRirekiDataTable: TBsyoIdoRirekiDataTable = {
  部所異動履歴データリスト: [],
}

//#endregion
